module.exports = __webpack_public_path__ + "static/giovanni-d933342e54045bfa42f9cf1ac7847b1b.jpeg";